__turbopack_context__.v({
  "share_location_prompt": "ShareLocationPrompt-module-scss-module__WJXxCq__share_location_prompt",
  "share_location_prompt__button": "ShareLocationPrompt-module-scss-module__WJXxCq__share_location_prompt__button",
  "share_location_prompt__error_message": "ShareLocationPrompt-module-scss-module__WJXxCq__share_location_prompt__error_message",
  "share_location_prompt__explanation": "ShareLocationPrompt-module-scss-module__WJXxCq__share_location_prompt__explanation",
  "share_location_prompt__headline": "ShareLocationPrompt-module-scss-module__WJXxCq__share_location_prompt__headline",
  "share_location_prompt__loading": "ShareLocationPrompt-module-scss-module__WJXxCq__share_location_prompt__loading",
  "share_location_prompt__subhead": "ShareLocationPrompt-module-scss-module__WJXxCq__share_location_prompt__subhead",
});
